import React from 'react';
import styled from 'styled-components';
import circuitos2 from "./../images/circuitos2.png";


const image = {uri: './../images/circuitos2.png'};

const Inicio = () => {
    return ( 
        <>
          <div>
          
          
         
          
          <img src={circuitos2} alt="logo" />
          </div>
     
    
    
  
       </>
     
     );
}
 




export default Inicio;